import { useState } from "react";
import Layout from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BarChart3, Users, Building2, BookOpen, CalendarDays } from "lucide-react";
import { StudentProgressReport } from "@/components/reports/StudentProgressReport";
import { BranchComparisonReport } from "@/components/reports/BranchComparisonReport";
import { SubjectAnalysisReport } from "@/components/reports/SubjectAnalysisReport";
import { AttendanceReport } from "@/components/reports/AttendanceReport";

const Reports = () => {
  const [activeTab, setActiveTab] = useState("progress");

  return (
    <Layout>
      <div className="container mx-auto py-6 px-4">
        <div className="flex items-center gap-3 mb-6">
          <BarChart3 className="h-6 w-6" />
          <div>
            <h1 className="text-2xl font-bold">Reports & Analytics</h1>
            <p className="text-sm text-muted-foreground">
              Comprehensive insights into student progress, branch performance, and more
            </p>
          </div>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList className="grid w-full grid-cols-4 lg:w-auto lg:inline-grid">
            <TabsTrigger value="progress" className="flex items-center gap-2">
              <Users className="h-4 w-4" />
              <span className="hidden sm:inline">Student Progress</span>
              <span className="sm:hidden">Progress</span>
            </TabsTrigger>
            <TabsTrigger value="branch" className="flex items-center gap-2">
              <Building2 className="h-4 w-4" />
              <span className="hidden sm:inline">Branch Comparison</span>
              <span className="sm:hidden">Branch</span>
            </TabsTrigger>
            <TabsTrigger value="subjects" className="flex items-center gap-2">
              <BookOpen className="h-4 w-4" />
              <span className="hidden sm:inline">Subject Analysis</span>
              <span className="sm:hidden">Subjects</span>
            </TabsTrigger>
            <TabsTrigger value="attendance" className="flex items-center gap-2">
              <CalendarDays className="h-4 w-4" />
              <span className="hidden sm:inline">Attendance</span>
              <span className="sm:hidden">Attend.</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="progress">
            <StudentProgressReport />
          </TabsContent>

          <TabsContent value="branch">
            <BranchComparisonReport />
          </TabsContent>

          <TabsContent value="subjects">
            <SubjectAnalysisReport />
          </TabsContent>

          <TabsContent value="attendance">
            <AttendanceReport />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default Reports;
